import React, { forwardRef, useState, useEffect } from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const CryptoSelectThumb = forwardRef(
  ({
    className,
    style,
    text,
    value,
    image,
    isActive,
    componentTheme,
    inGame,
    ...props
  }, forwardedRef) => {
    const [isStartAnimationInGame, setStartAnimationInGame] = useState(true);
    useEffect(() => {
      if (inGame) {
        setStartAnimationInGame(true);
        setTimeout(() => {
          setStartAnimationInGame(false);
        }, 500);
      } else {
        setStartAnimationInGame(true);
      }
    }, [inGame]);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        type: "button",
        className: cx(styles.box, {
          [styles.active]: !!isActive,
          [styles["in-game"]]: inGame
        }),
        ref: forwardedRef
      },
      /* @__PURE__ */ React.createElement("div", { className: styles["logo-container"] }, image && /* @__PURE__ */ React.createElement("img", { loading: "lazy", src: image, alt: text })),
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(styles.money, {
            [styles[componentTheme || ""]]: !!componentTheme,
            [styles.active]: isActive
          })
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: cx(styles.money__text, {
              [styles["fade-out"]]: inGame && isStartAnimationInGame,
              [styles["fade-in"]]: inGame && !isStartAnimationInGame
            })
          },
          inGame && isStartAnimationInGame === false ? /* @__PURE__ */ React.createElement(React.Fragment, null, "(In Game)") : value || text
        ),
        /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: styles.money__arrow,
            width: "20",
            height: "20",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.35356 10.8534C8.25981 10.947 8.13272 10.9996 8.00022 10.9996C7.86772 10.9996 7.74064 10.947 7.64689 10.8534L2.64689 5.85335C2.55857 5.75857 2.51049 5.63321 2.51277 5.50367C2.51506 5.37414 2.56753 5.25055 2.65914 5.15894C2.75075 5.06733 2.87434 5.01486 3.00387 5.01257C3.13341 5.01029 3.25877 5.05837 3.35356 5.14669L8.00022 9.79335L12.6469 5.14669C12.6927 5.09756 12.7479 5.05816 12.8092 5.03083C12.8705 5.00351 12.9367 4.98881 13.0039 4.98763C13.071 4.98644 13.1377 4.99879 13.2 5.02394C13.2622 5.04909 13.3188 5.08652 13.3662 5.134C13.4137 5.18147 13.4512 5.23803 13.4763 5.30029C13.5015 5.36255 13.5138 5.42923 13.5126 5.49637C13.5114 5.5635 13.4967 5.62971 13.4694 5.69105C13.4421 5.75238 13.4027 5.80758 13.3536 5.85335L8.35356 10.8534Z",
              fill: "currentColor"
            }
          )
        )
      )
    );
  }
);
CryptoSelectThumb.displayName = "CryptoSelectThumb";

export { CryptoSelectThumb };
//# sourceMappingURL=index.js.map
